import { Router, Request, Response } from "express";
import asyncHandler from "express-async-handler";

import { getRecipePhotos } from "./photos";
import { getRecipePreheat, updateRecipePreheat } from "./preheat";
import { getRecipeTime, updateRecipeTime } from "./time";
import { getRecipeInstructions, addRecipeInstructions, updateRecipeInstructions } from "./instructions";
import { getRecipeGeneral, updateRecipeGeneral } from "./general";
import { getRecipeIngredients, addRecipeIngredients, updateRecipeIngredients } from "./ingredients";

const router = Router();

// preheat
router.get(
	"/:id/preheat",
	asyncHandler(async (req: Request, res: Response) => getRecipePreheat(req, res)),
);

router.put(
	"/:id/preheat",
	asyncHandler(async (req: Request, res: Response) => updateRecipePreheat(req, res)),
);

// time
router.get(
	"/:id/time",
	asyncHandler(async (req: Request, res: Response) => getRecipeTime(req, res)),
);

router.put(
	"/:id/time",
	asyncHandler(async (req: Request, res: Response) => updateRecipeTime(req, res)),
);

// photos
router.get(
	"/:id/photos",
	asyncHandler(async (req: Request, res: Response) => getRecipePhotos(req, res)),
);

// general
router.get(
	"/:id/general",
	asyncHandler(async (req: Request, res: Response) => getRecipeGeneral(req, res)),
);

router.put(
	"/:id/general",
	asyncHandler(async (req: Request, res: Response) => updateRecipeGeneral(req, res)),
);

// ingredients
router.get(
	"/:id/ingredients",
	asyncHandler(async (req: Request, res: Response) => getRecipeIngredients(req, res)),
);

router.post(
	"/:id/ingredients",
	asyncHandler(async (req: Request, res: Response) => addRecipeIngredients(req, res)),
);

router.patch(
	"/:id/ingredients",
	asyncHandler(async (req: Request, res: Response) => updateRecipeIngredients(req, res)),
);

// instructions
router.get(
	"/:id/instructions",
	asyncHandler(async (req: Request, res: Response) => getRecipeInstructions(req, res)),
);

router.post(
	"/:id/instructions",
	asyncHandler(async (req: Request, res: Response) => addRecipeInstructions(req, res)),
);

router.patch(
	"/:id/instructions",
	asyncHandler(async (req: Request, res: Response) => updateRecipeInstructions(req, res)),
);

export default router;
